<template>
  <v-container>
    <v-row>
      <p class="text-h4 mb-4">Password</p>
    </v-row>
    <v-row>
      <v-text-field
          v-model="currentPassword.value"
          :rules="currentPassword.rules"
          :label="isEditing ? 'Current password' : 'Password'"
          :type="currentPassword.isMasked ? 'password': 'text'"
          :append-inner-icon="isEditing ? null : 'mdi-lock'"
          :append-icon="isEditing ? currentPassword.isMasked ? 'mdi-eye' : 'mdi-eye-off' : null"
          :bg-color="isEditing ? 'grey-lighten-3' : 'grey-lighten-1'"
          :loading="isLoading"
          :disabled="!isEditing || isLoading"
          @click:append="currentPassword.isMasked = !currentPassword.isMasked"
      />
    </v-row>
    <v-row>
      <v-expand-transition>
        <v-text-field
            v-show="isEditing"
            v-model="newPassword.value"
            :rules="isEditing ? newPassword.rules : []"
            :type="newPassword.isMasked ? 'password': 'text'"
            :append-inner-icon="isEditing ? null : 'mdi-lock'"
            :append-icon="isEditing ? newPassword.isMasked ? 'mdi-eye' : 'mdi-eye-off' : null"
            :bg-color="isEditing ? 'grey-lighten-3' : 'grey-lighten-1'"
            :loading="isLoading"
            :disabled="isLoading"
            label="New password"
            @click:append="newPassword.isMasked = !newPassword.isMasked"
        />
      </v-expand-transition>
    </v-row>
    <v-row>
      <v-expand-transition>
        <v-text-field
            v-show="isEditing"
            v-model="repeatedNewPassword.value"
            :rules="newPassword.rules"
            :type="repeatedNewPassword.isMasked ? 'password': 'text'"
            :append-inner-icon="isEditing ? null : 'mdi-lock'"
            :append-icon="isEditing ? repeatedNewPassword.isMasked ? 'mdi-eye' : 'mdi-eye-off' : null"
            :bg-color="isEditing ? 'grey-lighten-3' : 'grey-lighten-1'"
            :loading="isLoading"
            :disabled="isLoading"
            label="Confirm new password"
            @click:append="repeatedNewPassword.isMasked = !repeatedNewPassword.isMasked"
        />
      </v-expand-transition>
    </v-row>
    <v-row>
      <v-spacer/>
      <v-col
          cols="auto"
          class="pt-0"
      >
        <v-btn
            v-if="isEditing"
            :block="true"
            color="grey-lighten-3"
            @click="cancelEditing"
        >
          Cancel
        </v-btn>
      </v-col>
      <v-col
          cols="auto"
          class="pr-0 pt-0"
      >
        <v-btn
            :text="isEditing ? 'Save password' : 'Change password'"
            :block="true"
            color="success"
            @click="changeClick"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ProfilePasswordCard",
  emits: ['switchEditState', 'submitPassword'],
  props: {
    isLoading: Boolean,
    isEditing: Boolean,
  },
  data() {
    return {
      currentPassword: {
        value: '*******',
        placeholder: '*******',
        isMasked: true,
        rules: [
          v => !!v || 'Password is required'
        ]
      },
      newPassword: {
        value: null,
        isMasked: true,
        rules: [
          v => !!v || 'Password is required',
          v => /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/.test(v) || 'Password must contain at least lowercase letter, one number, a special character and one uppercase letter',
          v => v && (this.newPassword.value === this.repeatedNewPassword.value || !this.newPassword.value || !this.repeatedNewPassword.value || !this.currentPassword.value) || 'Password must match in both fields',
          v => v && this.newPassword.value !== this.currentPassword.value || 'Password must be different from the current one'
        ]
      },
      repeatedNewPassword: {
        value: null,
        isMasked: true,
      },
    }
  },
  methods: {
    changeClick() {
      if (this.isEditing) {
        this.submitPassword()
      } else {
        this.edit()
      }
    },
    edit() {
      this.$emit('switchEditState')
      this.currentPassword.value = null
    },
    cancelEditing() {
      this.$emit('switchEditState')
      this.currentPassword.value = this.currentPassword.placeholder
      this.newPassword.value = null
      this.repeatedNewPassword.value = null
    },
    submitPassword() {
      this.$emit('submitPassword', {
        currentPassword: this.currentPassword.value,
        newPassword: this.newPassword.value,
      })
    }
  }
}
</script>

<style scoped>

</style>